import { orderService } from '../_services';
import { router } from '../_helpers';

export const orders = {
    namespaced: true,
    state: {
        all: {},
        lastOrder: {}
    },
    actions: {
      
        getAll({ commit }) {
            commit('getAllRequest');

            orderService.getAll()
                .then(
                    orders => commit('getAllSuccess', orders),
                    error => commit('getAllFailure', error)
                );
        },
        
        saveNew({ dispatch, commit }, { deliverydate, basket }) {
            commit('saveNewRequest');

            orderService.saveNew( deliverydate, basket )
               .then(
                    order => {
                        commit('saveNewSuccess', { deliverydate, basket } );
                        router.push('/thankyou');                        
                    },
                    error => {
                        commit('saveNewError', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        }
    },
    mutations: {

        saveNewRequest(state){
            state.lastOrder = { loading: true };
        },
        saveNewSuccess(state, order){
            state.lastOrder = order ;
        },
        saveNewError(state, error ){
            state.lastOrder = { error };
        },


        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, orders) {
            console.log(orders)
            state.all = { items: orders };
        },
        getAllFailure(state, error) {
            state.all = { error };
        }
    }
}